
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        company: String,
        small: Boolean,
    },
});
